/* Impression SCDM — LA FENETRE D APPROBATION, VERSION UTILISABLE.

   CE QUI N ALLAIT PAS
   -------------------
   1. La vignette etait minuscule et, sur un PDF, il n y en avait pas du tout :
      juste le mot « PDF » dans un carre gris. Le client devait approuver une
      commande sans revoir ce qu il avait dessine.
   2. Rien ne permettait de revenir sur UN design. On pouvait fermer la fenetre,
      mais pas dire « celui-la, je veux le refaire » : il fallait tout retirer
      et tout recommencer.
   3. Le bouton d approbation etait sombre sur fond clair, et son etat desactive
      etait presque invisible. On ne savait ni qu il etait la, ni pourquoi il ne
      repondait pas.
   4. Une fois « Envoi en cours… » affiche, plus rien ne pouvait le sortir de
      cet etat : si la caisse tardait, la fenetre restait figee.

   CE QUE CE FICHIER AJOUTE
   ------------------------
   - UN VRAI APERCU. Au moment ou le design est ajoute, on photographie la toile
     du configurateur - dessin ET ligne de coupe magenta - et on garde l image
     avec le design. Elle marche donc aussi pour un PDF, dont le navigateur ne
     sait rien afficher. Un clic dessus l ouvre en grand.
   - MODIFIER CE DESIGN. On retire la ligne, on remet le configurateur
     exactement dans l etat ou il etait - fichier, format, forme, matiere,
     vernis, quantite - et on referme la fenetre. Le client reprend ou il en
     etait au lieu de tout refaire.
   - RETIRER. Sans passer par le recapitulatif de droite.
   - UN FILET SUR L ENVOI. Si la caisse n a pas repondu apres quinze secondes,
     le bouton redevient cliquable et on le dit.

   COMMENT IL S ACCROCHE SANS TOUCHER A scdm.js
   --------------------------------------------
   scdm.js remplit #scdmApproListe a chaque ouverture. On observe cette liste :
   des qu elle est reecrite, on redecore. Pour retirer une ligne, on ne touche
   pas au tableau window.SCDM.commande - on CLIQUE le bouton « x » que scdm.js
   a deja pose dans le recapitulatif (data-retirer). C est lui qui sait
   recalculer le total, les rabais et le minimum de commande. On ne duplique
   aucun calcul d argent.

   Charge par snippets/scdm-approbation.liquid, en defer. */

(function () {
  'use strict';

  var MAX_APERCU = 1100;   /* largeur maximale de l image gardee, en pixels */
  var ATTENTE_ENVOI = 15000;

  var etats = [];          /* l etat du configurateur au moment de chaque ajout */
  var photo = null, etatPhoto = null;

  function $(s) { return document.querySelector(s); }
  function D() { return window.SCDM_DATA || {}; }
  function S() { return window.SCDM; }

  /* ------------------------------------------------------------ la photo */

  /* La toile du configurateur porte le dessin ; scdm-coupe.js pose la ligne de
     coupe sur une deuxieme toile, par-dessus. On les empile pour que l apercu
     montre exactement ce que le client voit. */
  function capturer() {
    var toile = document.getElementById('scdmCanvas');
    if (!toile || !toile.width) return null;
    try {
      var ech = Math.min(1, MAX_APERCU / toile.width);
      var c = document.createElement('canvas');
      c.width = Math.round(toile.width * ech);
      c.height = Math.round(toile.height * ech);
      var ctx = c.getContext('2d');
      ctx.drawImage(toile, 0, 0, c.width, c.height);
      var coupe = document.getElementById('scdmCoupe');
      if (coupe && coupe.width) ctx.drawImage(coupe, 0, 0, c.width, c.height);
      return c.toDataURL('image/png');
    } catch (e) {
      return null;   /* toile salie par une image d une autre origine */
    }
  }

  function instantane() {
    var e = S() && S().etat;
    if (!e) return null;
    return {
      taille: e.taille, larg: e.larg, haut: e.haut, qte: e.qte,
      forme: e.forme, matiere: e.matiere, finition: e.finition,
      unite: e.unite, fichier: e.fichier, nom: (($('#scdmNom') || {}).value || '')
    };
  }

  /* On photographie AVANT que scdm.js traite le clic : apres, la toile peut
     deja avoir ete videe. On attache ensuite au design qui vient de naitre. */
  document.addEventListener('click', function (ev) {
    var b = ev.target && ev.target.closest ? ev.target.closest('#scdmAjouter') : null;
    if (!b || b.disabled) return;
    photo = capturer();
    etatPhoto = instantane();
    var avant = ((S() && S().commande) || []).length;
    setTimeout(function () {
      var C = (S() && S().commande) || [];
      if (C.length <= avant) { photo = null; etatPhoto = null; return; }
      C[C.length - 1].scdmApercu = photo;
      etats[C.length - 1] = etatPhoto;
      photo = null; etatPhoto = null;
    }, 80);
  }, true);

  /* --------------------------------------------------------- la loupe */

  function loupe(src, titre) {
    var l = document.getElementById('scdmApproLoupe');
    if (!l) return;
    l.querySelector('img').src = src;
    l.querySelector('.lp-titre').textContent = titre || '';
    l.hidden = false;
  }

  document.addEventListener('click', function (ev) {
    var l = document.getElementById('scdmApproLoupe');
    if (!l || l.hidden) return;
    var t = ev.target;
    if (t.closest && t.closest('[data-loupe-fermer]')) { l.hidden = true; return; }
    if (t.closest && t.closest('.lp-boite')) return;
    if (t === l || (t.closest && t.closest('#scdmApproLoupe'))) l.hidden = true;
  });

  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Escape') return;
    var l = document.getElementById('scdmApproLoupe');
    if (l && !l.hidden) { l.hidden = true; ev.stopPropagation(); }
  });

  /* --------------------------------------------- remettre le configurateur */

  function poserOption(champ, val) {
    var b = document.querySelector('[data-champ="' + champ + '"][data-val="' + val + '"]');
    if (b) { b.click(); return true; }
    return false;
  }

  function restaurer(s) {
    if (!s) return;
    var S0 = S();
    if (!S0) return;

    if (s.fichier && typeof S0.chargerFichier === 'function') S0.chargerFichier(s.fichier);

    var sel = $('#scdmTaille');
    if (sel) {
      sel.value = s.taille;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      if (s.taille === 'custom') {
        var L = $('#scdmLargeur'), H = $('#scdmHauteur');
        if (L) { L.value = s.larg; L.dispatchEvent(new Event('input', { bubbles: true })); }
        if (H) { H.value = s.haut; H.dispatchEvent(new Event('input', { bubbles: true })); }
      }
    }

    poserOption('forme', s.forme);
    poserOption('matiere', s.matiere);
    poserOption('finition', s.finition);

    /* La quantite : on essaie la tuile, sinon le champ exact. */
    if (!poserOption('qte', s.qte)) {
      var q = $('#scdmQteExacte');
      if (q) { q.value = s.qte; q.dispatchEvent(new Event('input', { bubbles: true })); }
    }

    var nom = $('#scdmNom');
    if (nom && s.nom) nom.value = s.nom;
  }

  /* Retirer une ligne : on clique le « x » que scdm.js a pose dans le
     recapitulatif. Lui seul sait refaire le total, les rabais et le minimum. */
  function retirer(i) {
    var x = document.querySelector('[data-retirer="' + i + '"]');
    if (!x) return false;
    etats.splice(i, 1);
    x.click();
    return true;
  }

  function fermerFenetre() {
    var f = document.querySelector('#scdmAppro [data-fermer]');
    if (f) f.click();
  }

  /* ------------------------------------------------------- la decoration */

  function decorer() {
    var liste = document.getElementById('scdmApproListe');
    if (!liste) return;
    var C = (S() && S().commande) || [];
    var lis = Array.prototype.slice.call(liste.children);

    lis.forEach(function (li, i) {
      if (li.dataset.scdmPlus === '1') return;
      var d = C[i];
      if (!d) return;
      li.dataset.scdmPlus = '1';
      li.classList.add('ap-item');

      /* 1. La vignette devient une vraie image, cliquable. */
      var vig = li.querySelector('.ap-vig');
      if (vig && d.scdmApercu) {
        vig.innerHTML = '';
        var img = new Image();
        img.src = d.scdmApercu;
        img.alt = d.nom || 'Aperçu du design';
        vig.appendChild(img);
        vig.classList.add('cliquable');
        vig.setAttribute('role', 'button');
        vig.setAttribute('tabindex', '0');
        vig.setAttribute('title', 'Voir en grand');
        vig.addEventListener('click', function () { loupe(d.scdmApercu, d.nom || ''); });
        vig.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); loupe(d.scdmApercu, d.nom || ''); }
        });
      }

      /* 2. Les trois actions, sous le texte de la ligne. */
      var txt = li.querySelector('.ap-txt');
      if (!txt) return;
      var act = document.createElement('div');
      act.className = 'ap-act';

      if (d.scdmApercu) {
        var bV = document.createElement('button');
        bV.type = 'button'; bV.className = 'ap-a';
        bV.innerHTML = '<span aria-hidden="true">⤢</span> Voir en grand';
        bV.addEventListener('click', function () { loupe(d.scdmApercu, d.nom || ''); });
        act.appendChild(bV);
      }

      if (etats[i]) {
        var bM = document.createElement('button');
        bM.type = 'button'; bM.className = 'ap-a';
        bM.innerHTML = '<span aria-hidden="true">✎</span> Modifier ce design';
        bM.addEventListener('click', function () {
          var s = etats[i];
          if (!retirer(i)) return;
          fermerFenetre();
          setTimeout(function () {
            restaurer(s);
            var cible = document.getElementById('configurateur');
            if (cible) cible.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 120);
        });
        act.appendChild(bM);
      }

      var bR = document.createElement('button');
      bR.type = 'button'; bR.className = 'ap-a ap-a-sup';
      bR.innerHTML = '<span aria-hidden="true">✕</span> Retirer';
      bR.addEventListener('click', function () {
        if (!retirer(i)) return;
        /* Plus rien a approuver : on ferme. Sinon on rouvre pour redessiner. */
        setTimeout(function () {
          var C2 = (S() && S().commande) || [];
          if (!C2.length) { fermerFenetre(); return; }
          if (typeof S().ouvrirAppro === 'function') S().ouvrirAppro();
        }, 60);
      });
      act.appendChild(bR);

      txt.appendChild(act);
    });
  }

  /* ------------------------------------------------------- le filet d envoi */

  function filetEnvoi() {
    var b = document.getElementById('scdmApproSuite');
    if (!b) return;
    b.addEventListener('click', function () {
      var libelle = b.dataset.libelle || 'Approuver et poursuivre';
      setTimeout(function () {
        if (!b.disabled) return;
        b.disabled = false;
        b.textContent = libelle;
        var err = document.getElementById('scdmApproErreur');
        if (err && !err.classList.contains('on')) {
          err.className = 'ap-erreur on';
          err.textContent = 'La caisse met du temps à répondre. Vous pouvez réessayer, ' +
            'ou fermer cette fenêtre — votre commande est conservée.';
        }
      }, ATTENTE_ENVOI);
    });
  }

  /* ------------------------------------------------------------ demarrage */

  function demarrer() {
    var liste = document.getElementById('scdmApproListe');
    if (!liste) return;

    /* QTE_MIN est passe a 1 le 5 septembre 2026 pour la signalisation, mais le
       champ de quantite exacte etait reste bloque a 10 dans le HTML. */
    var q = document.getElementById('scdmQteExacte');
    if (q && D().QTE_MIN) q.min = D().QTE_MIN;

    new MutationObserver(function () { decorer(); }).observe(liste, { childList: true });
    decorer();
    filetEnvoi();
  }

  function quandPret(n) {
    if (document.getElementById('scdmApproListe') && window.SCDM) return demarrer();
    if ((n || 0) > 80) return;
    setTimeout(function () { quandPret((n || 0) + 1); }, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { quandPret(0); });
  } else {
    quandPret(0);
  }
})();
